<template>
  <div class="tab-pane fade active show" id="realtime-gender-content" role="tabpanel" aria-labelledby="realtime-gender-content-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">遊客中心</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in peopleAnalysisScenicArea" :key="index" :value="list.id">{{list.name}}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>
        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk"
            :disabled="isWaitResult">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitResult">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">性別即時</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="realTimeGenderTable" class=" w3-table-all table table-hover table-striped">
                  <thead class="table-dark ">
                    <tr>
                      <th  width="5%">#</th>
                      <th scope="col">時間</th>
                      <th scope="col">景區</th>
                      <th scope="col">男性</th>
                      <th scope="col">女性</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in peopleAnalysisDataList"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td style="white-space: pre-line;">{{ item.time }}</td>  <!-- style讓 \n可以換行-->
                      <td>{{ item.scenicAreaName }}</td>
                      <td>{{ item.manCount }} / {{ item.manRatio }} %</td>
                      <td>{{ item.womanCount }} / {{ item.womanRatio }} %</td>
                    </tr>
                  </tbody>
                </table>

            </div>
          </div>
        </div>

        <!-- <div class="col">
          <div id="realAreaCarChart">
            <apexchart type="donut" height="200" :options="chartSetting" :series="chartData"></apexchart>
          </div>
        </div> -->
      </div>

    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import moment from "moment";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectType: 1,
      typeList: [{description:'性別', type: CONST.PEOPLE_ATTRIBUTE_TYPE.GENDER}],
      peopleAnalysisDataList: [],

      isWaitResult: false,
      maxSelectTime: moment().startOf('m').toISOString(),

    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


    peopleAnalysisScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE))
    },

    searchTime() {
      return `${moment(this.startTime).format('YYYY/MM/DD HH:mm')}~${moment(this.endTime).format('YYYY/MM/DD HH:mm')}`
    },

    searchAreaName() {
      const area = this.scenicAreaList.find(s => s.id === this.selectScenicAreaId)
      return area ? area.name : ''
    }
  },
  methods: {
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },
    async queryCSV() {
      this.isWaitResult = true
      const peopleAnalysisDataList = await this.searchData()
      if(Utils.isEmptyObject(peopleAnalysisDataList)) {
        return
      }

      const csvContent = [['時間', '遊客中心', '男性' ,'女性']]
      peopleAnalysisDataList.forEach(item => {
        const row = []
        row.push(item.time.replace(/\n/g, ''))
        row.push(item.scenicAreaName)
        row.push(`${item.manCount} / ${item.manRatio}%`)
        row.push(`${item.womanCount} / ${item.womanRatio}%`)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_遊客即時性別.csv`
      exportCSV.genCSVFile(csvContent, fileName)
      this.isWaitResult = false
    },

    async queryElk () {
      this.isWaitResult = true
      this.peopleAnalysisDataList = await this.searchData()
      console.log('this.peopleAnalysisDataList', this.peopleAnalysisDataList)
      this.updateTable()
      this.isWaitResult = false
    },

    async searchData(){
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if(this.selectScenicAreaId ===""){
        alert("請選擇風景區");
        return;
      }

      const condition = {
        startTime: moment(this.startTime).startOf('minute').valueOf(),
        endTime: moment(this.endTime).startOf('minute').valueOf(),
        // scenicAreaId: "", 沒有景區id則是全部
        type: this.selectType
      }

      if(this.selectScenicAreaId === -1){

        const areaId=  this.peopleAnalysisScenicArea.map((s) => s.id);
        // console.log("area",areaId)
        condition.scenicAreaId = areaId;
          // console.log("condition.areas",condition.areas);
          }

      if(this.selectScenicAreaId > -1) {
        condition.scenicAreaId= this.selectScenicAreaId
      }



      await this.$store.dispatch('peopleAttribute/getPeopleAttributeListPerHour', condition)
      const result =  this.$store.getters['peopleAttribute/getSearchGenderPerHour']

      const total = {
        time: '統計',
        scenicAreaName: '',
        manCount: 0,
        manRatio: 0,
        womanCount: 0,
        womanRatio: 0,
      }

      const dataList = result.map(e => {
        e.time = `${moment(e.startTime).format('YYYY-MM-DD')} \n ${moment(e.startTime).format('HH')}~${moment(e.startTime).add(1, 'h').format('HH')}`

        total.manCount = total.manCount + e.manCount
        total.womanCount = total.womanCount + e.womanCount

        return e
      })

      const totalManWoman = total.manCount + total.womanCount
      if(totalManWoman === 0) {
        total.manRatio = 0
        total.womanRatio = 0  
      } else {
        total.manRatio = Math.round((total.manCount / totalManWoman) * 100);
        total.womanRatio = Math.round((total.womanCount / totalManWoman) * 100);
      }
      

      dataList.push(total)
      return dataList
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.startTime)) {
        return "-";
      }

      const time = moment(item.startTime)
      return `${time.format('HH')}~${time.add(1, 'h').format('HH')}`
    },

    initTable: function () {
      this.table = $("#realTimeGenderTable").DataTable({
        aoColumns: [
          ...new Array($("#realTimeGenderTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });
    },

    updateTable() {
      if(!Utils.isEmptyObject(this.table)){
        this.table.destroy()
      }
      
      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  }
};
</script>
<style lang="scss" scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody > tr > td , tr > th{
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
} /* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
} /* table不超過div */
</style>
